<template>
    <div id="oleo-asset-card-widget-component">
        <v-card class="elevation-0">
            <v-card-title>
                <HeaderWidgetComponent
                    :actions="[
                        {
                            title: $t('list_tank_equipmement_component.edit_cuve'),
                            icon: 'mdi-pencil-outline',
                            emit: 'openManageNameEquipmentFormDialog',
                            has_access: userHasAccess('TNK', role_all_access),
                        },
                        {
                            title: $t('list_tank_equipmement_component.manage_alert'),
                            icon: 'mdi-bell-outline',
                            emit: 'goToManageAlertPage',
                            has_access: userHasAccess('BASE', role_vision),
                        },
                    ]"
                    :is_open="is_open"
                    :title="asset.name"
                    widget_name="oleo-asset-card-widget-component"
                    v-on:goToManageAlertPage="$router.push('/equipment/manage_alert/' + asset.id_asset)"
                    v-on:openManageEquipmentFormDialog="$refs.manageEquipmentFormDialog.openManageEquipmentFormDialog(asset)"
                    v-on:openManageNameEquipmentFormDialog="
                        $refs.manageNameEquipmentFormDialog.openManageNameEquipmentFormDialog(asset)
                    "
                />
            </v-card-title>

            <v-expand-transition>
                <div v-show="is_open">
                    <v-card-text>
                        <div class="d-flex justify-center">
                            <DisplayAssetLevelComponent :asset="asset" :scale="is_mobile ? 0.8 : 1.2" show_indicator />
                        </div>

                        <v-row class="font-12 mx-0 my-4">
                            <v-col class="px-4 py-1 mb-1" cols="6" md="3">
                                <span class="font-color-medium">{{ $t('list_tank_equipmement_component.volume') }}</span>
                                <p class="mb-0 font-weight-bold">
                                    {{
                                        asset.is_subscription_device_active
                                            ? numberWithSpaces(Math.round(asset.actual_volume), 0) + ' L'
                                            : '-'
                                    }}
                                </p>
                            </v-col>
                            <v-divider color="white" vertical />

                            <v-col class="px-4 py-1 mb-1" cols="6" md="3">
                                <span class="font-color-medium">{{ $t('list_tank_equipmement_component.useful_hollow') }}</span>
                                <p class="mb-0 font-weight-bold">
                                    {{
                                        asset.is_subscription_device_active
                                            ? numberWithSpaces(Math.round(asset.useful_hollow), 0) + ' L'
                                            : '-'
                                    }}
                                </p>
                            </v-col>
                            <v-divider v-if="!is_mobile" color="white" vertical />

                            <v-col class="px-4 py-1 mb-1" cols="6" md="3">
                                <span class="font-color-medium">{{ $t('list_tank_equipmement_component.level') }}</span>
                                <p class="mb-0 font-weight-bold">
                                    {{
                                        asset.is_subscription_device_active
                                            ? numberWithSpaces(Math.round(asset.remaining_level), 0) + ' %'
                                            : '-'
                                    }}
                                </p>
                            </v-col>
                            <v-divider color="white" vertical />

                            <v-col class="px-4 py-1 mb-1" cols="6" md="3">
                                <span class="font-color-medium">{{ $t('list_tank_equipmement_component.product') }}</span>
                                <p class="mb-0 font-weight-bold">
                                    {{ asset.asset_liquid ? asset.asset_liquid.name : '-' }}
                                </p>
                            </v-col>
                        </v-row>

                        <template v-for="(device, index) in asset.devices">
                            <div :key="index" class="d-flex align-center gap-2 mb-2">
                                <img :src="device.path_image_device_referentiel" height="40" />
                                <div class="d-flex align-center flex-wrap gap-2">
                                    {{ device.device_number }}
                                    <ChipsLastStatement :date="device.date_last_emission" />
                                    <DisplayDeviceBatteryLevelComponent :battery="device.battery" />
                                </div>
                            </div>
                        </template>

                        <template v-if="!!tags.find((tag) => tag.label === 'Commande automatique')">
                            <v-alert color="success" dense icon="mdi-refresh" text>
                                {{ $t('oleo_asset_card_widget_component.automatic_order') }}
                            </v-alert>
                        </template>
                    </v-card-text>
                </div>
            </v-expand-transition>
        </v-card>

        <ManageEquipmentFormDialogComponent
            v-if="userHasAccess('TNK', this.role_admin)"
            ref="manageEquipmentFormDialog"
            v-on:refresh:tank="$emit('refresh:tank')"
        />

        <ManageNameEquipmentFormDialogComponent
            v-if="userHasAccess('TNK', this.role_edit)"
            ref="manageNameEquipmentFormDialog"
            data-cy="manage-name-equipment-dialog-component"
            v-on:refresh:tank="$emit('refresh:tank')"
        />
    </div>
</template>

<script>
import DisplayAssetLevelComponent from '@/components/equipment/containment/DisplayAssetLevelComponent.vue'
import ChipsLastStatement from '@/components/global/containment/ChipsLastStatement.vue'
import HeaderWidgetComponent from '@/components/equipment/widget/HeaderWidgetComponent.vue'
import ManageEquipmentFormDialogComponent from '@/components/equipment/form/ManageEquipmentFormDialogComponent.vue'
import AssetRepository from '@/repositories/AssetRepository'
import DisplayDeviceBatteryLevelComponent from '@/components/global/DisplayDeviceBatteryLevelComponent.vue'
import ManageNameEquipmentFormDialogComponent from '../../form/ManageNameEquipmentFormDialogComponent.vue'

export default {
    name: 'OleoAssetCardWidgetComponent',
    components: {
        DisplayDeviceBatteryLevelComponent,
        ManageEquipmentFormDialogComponent,
        HeaderWidgetComponent,
        DisplayAssetLevelComponent,
        ChipsLastStatement,
        ManageNameEquipmentFormDialogComponent,
    },
    created() {
        this.getAssetTags()
    },
    methods: {
        getAssetTags() {
            AssetRepository.getAssetTags(this.asset.id_asset)
                .then((success) => {
                    this.tags = success.data.data
                })
                .catch((error) => {
                    this.manageError(error)
                })
        },
    },
    data() {
        return {
            tags: [],
        }
    },
    props: {
        asset: {
            type: Object,
            required: true,
        },
        is_open: {
            type: Boolean,
            required: false,
            default: false,
        },
    },
}
</script>
